import React, { useState } from 'react'
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {useSelector} from "react-redux";
import Cookies from 'js-cookie';
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from 'react-router-dom';

export default function Paypal(props) {

    const navigate = useNavigate();

    // Redux State 
    const token = useSelector(state => state.auth.token);
    const userData = useSelector(state => state.auth.data);

    const savePayment = async (paymentdata) => {
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/payments`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`
            }, 
            body: paymentdata
        })
        .then(r => r.json())
        .then(response => {
            if(response.success){  
                // window.location = props.redirectURL;
                // set ispay check in job card to true
                // this is the condition that is used to redirect freelancer on job detail page untile this is true
                
                toast.success(response.message);                
                var inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000); // for testing 50 minutes
                Cookies.set(`isPaid${props.job.id}`, "paid", {
                    expires: inFiveMinutes
                });
                Cookies.set(`jobid${props.job.id}`, `${props.job.id}`, {
                    expires: inFiveMinutes
                });
                props.setisPaid(true);
                props.handleClose();

                setTimeout(() => {
                    return navigate(`/jobs/${props?.job?.id}`, { replace: true });
                }, 1000);

            }
        })
    }

    return (
        <>
            <PayPalScriptProvider options={{ "client-id": "AQG9mq5jk8ejpL9XcQZmBf0Mmt-kpihSgj-HeCOZPIV_lSw0XJsdWTXTQ9_enYsdXTxmv0i11Yxbt2cm" }}>
                <PayPalButtons
                     createOrder={(data, actions) => {
                        return actions.order.create({
                            purchase_units: [
                                {
                                    description: props.job.title,
                                    amount: {
                                        value: "1.0",
                                    },
                                },
                            ],
                        });
                    }}
                    onApprove={(data, actions) => {
                        return actions.order.capture().then((details) => {
                            // console.log("Transaction Completed: ",details);
                            
                            // createing object 
                            let paymentdata = new FormData();
                            paymentdata.append("user_id", userData?.id);
                            paymentdata.append("amount_captured", details?.purchase_units[0]?.amount?.value);
                            paymentdata.append("currency", details?.purchase_units[0]?.amount?.currency_code);
                            paymentdata.append("response_object", details);
                            paymentdata.append("expiry_date", "2022-07-23");


                            // saving payment 
                            savePayment(paymentdata);
                            
                        });
                    }}
                />
            </PayPalScriptProvider>
            <ToastContainer />
        </>
    )
}



/*

createOrder={(data, actions) => {
                        return actions.order.create({
                            purchase_units: [
                                {
                                    description: "PACKAGE_NAME_HERE",
                                    amount: {
                                        // value: "PRICE_IN_NUMBERS",
                                        value: "0.001"
                                    },
                                },
                            ],
                        });
                    }}
                    onApprove={(data, actions) => {
                        return actions.order.capture().then((details) => {
                            // const name = details.payer.name.given_name;
                            // alert(`Transaction completed by ${name}`);

                            // CREATE_DATA_OBJECT_WITH_DETAILS
                            const paymentDetails = {
                                user_id: "USER_ID",
                                amount_captured: "PRICE",
                                currency: "USD",
                                response_object: details,
                                expiry_date: "2022-07-23"
                            };
                            console.log(details);
                            // call payment api here
                        });
                    }
                    }

*/